import { createContext, useContext, useMemo, useState } from "react";

const TrackerChromeContext = createContext(null);

export function PerformanceTrackerChromeProvider({ children }) {
  const [displayMode, setDisplayMode] = useState("compact");
  const value = useMemo(
    () => ({
      expanded: displayMode === "expanded",
      expand: () => setDisplayMode("expanded"),
      collapse: () => setDisplayMode("compact"),
      toggle: () =>
        setDisplayMode((mode) => (mode === "expanded" ? "compact" : "expanded")),
    }),
    [displayMode],
  );

  return (
    <TrackerChromeContext.Provider value={value}>
      {children}
    </TrackerChromeContext.Provider>
  );
}

export function useTrackerChromeOptional() {
  return useContext(TrackerChromeContext);
}
